import { client } from '@/sanity/lib/client';
import { getClient } from '@/sanity/lib/getClient';

import { BlogPageDataInterface } from '../assets/interfaces/blogPageDataInterface';
import { BlogPostInterface } from '../assets/interfaces/blogPostInterface';
import { BlogTagInterface } from '../assets/interfaces/blogTagInterface';
import { blogPageQuery } from '../assets/queries/blogPageQuery';
import { getBlogPostDataQuery } from '../assets/queries/blogPostDataQuery';
import { getBlogPostsQuery } from '../assets/queries/blogPostsQuery';
import { getBlogTagDataQuery } from '../assets/queries/blogTagDataQuery';
import { blogTagsQuery } from '../assets/queries/blogTagsQuery';
import { getReadNextPostsQuery } from '../assets/queries/readNextPostsQuery';
import { getSameTagBlogPosts } from '../assets/queries/sameTagPostsQuery';

export const getBlogPageData = async () => {
    try {
        const blogData: BlogPageDataInterface = await client.fetch(blogPageQuery);
        return blogData;
    } catch (e: any) {
        console.log('BlogData Fetching Error:', e); //TODO: FIX LATER
    }
};

export const getBlogTags = async () => {
    try {
        const blogTags: BlogTagInterface[] = await client.fetch(blogTagsQuery);
        return blogTags;
    } catch (e: any) {
        console.log('BlogTags Fetching Error:', e); //TODO: FIX LATER
    }
};

export const getBlogPosts = async (tag: string | undefined, offset: number, limit: number) => {
    if (!tag) {
        throw new Error('No tag!');
    }

    try {
        const blogPosts: BlogPostInterface[] = await client.fetch(
            getBlogPostsQuery(tag, offset, limit)
        );
        return blogPosts;
    } catch (e: any) {
        console.log('BlogPosts Fetching Error:', e); //TODO: FIX LATER
        throw new Error(e.message);
    }
};

export const getBlogTagData = async (slug: string | undefined) => {
    if (!slug) {
        throw new Error('No slug!');
    }

    try {
        const tagData: BlogPageDataInterface = await client.fetch(getBlogTagDataQuery(slug));
        return tagData;
    } catch (e: any) {
        console.log('BlogTagData Fetching Error:', e); //TODO: FIX LATER
    }
};

export const getBlogPostData = async ({
    previewToken,
    slug,
}: {
    previewToken: string | undefined;
    slug: string;
}) => {
    const _client = getClient(previewToken);

    try {
        const blogPostData: BlogPostInterface = await _client.fetch(getBlogPostDataQuery(slug));

        if (!blogPostData) {
            return null;
        }

        if (!blogPostData.readNextPosts?.length) {
            const readNextPosts = [];
            if (blogPostData.tags && blogPostData.tags[0]._id) {
                const sameTagPosts = await _client.fetch(
                    getSameTagBlogPosts(blogPostData.tags[0]._id, blogPostData._id)
                );
                if (sameTagPosts.length) {
                    readNextPosts.push(...sameTagPosts);
                } else {
                    const posts = await _client.fetch(getReadNextPostsQuery(blogPostData._id));
                    readNextPosts.push(...posts);
                }
            } else {
                const posts = await _client.fetch(getReadNextPostsQuery(blogPostData._id));
                readNextPosts.push(...posts);
            }
            blogPostData.readNextPosts = readNextPosts;
        }

        return blogPostData;
    } catch (e: any) {
        console.log('BlogPostData Fetching Error:', e); //TODO: FIX LATER
    }
};
